import { render, staticRenderFns } from "./card-buy.vue?vue&type=template&id=ae0b6bd0&scoped=true"
import script from "./card-buy.vue?vue&type=script&lang=js"
export * from "./card-buy.vue?vue&type=script&lang=js"
import style0 from "./card-buy.vue?vue&type=style&index=0&id=ae0b6bd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0b6bd0",
  null
  
)

export default component.exports